import type { Chat, Message, SendMessageInputWritable } from '@/shared/api';

enum OutgoingStatus {
  PENDING = 'pending',
  SENDING = 'sending',
  FAILED = 'failed',
}

type OutgoingMessage = {
  chatId: Chat['id'];
  clientMessageId: string;
  content: SendMessageInputWritable['content'];
  createdAt: string;
  replyToMessageId?: string;
  senderId: string;
  status: OutgoingStatus;
};

type OutgoingQueueTransition = {
  current: OutgoingMessage;
  previous: OutgoingMessage | null;
  serverMessage?: Message;
};

type OutgoingQueueStorage = {
  load: () => Promise<OutgoingMessage[]>;
  remove: (clientMessageId: string) => Promise<void>;
  save: (message: OutgoingMessage) => Promise<void>;
};

export {
  OutgoingStatus,
  type OutgoingMessage,
  type OutgoingQueueStorage,
  type OutgoingQueueTransition,
};
